/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "./router";
import LRS from "./services/lrsService";
import userService from "./services/userService";
import translationService from "./services/translationService";
import i18n from "./i18n";
import localUsers from "./users/user.json";


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
       user: localStorage.getItem("user") || "",
       translation: localStorage.getItem("translation") || "",
       lang: localStorage.getItem("lang") || "EN",
       country: localStorage.getItem("country") || "UK",
       modulename: localStorage.getItem("modulename") || ""
    },
    mutations: {
        init(state, {user, translation, lang, country, module}) {
            state.user = user;
            state.translation = translation;
            state.lang = lang;
            state.country = country;
            state.modulename = module;
        },
        setLanguage(state, {translations, lang}){
            state.translation = translations;
            state.lang = lang;
        },
        changeLanguage(state, lang){
            state.lang = lang;
        }
    },

    actions: {
        enterModule({ commit }, {module, lang, chapters}) {
            let user;

            userService.getUser(module).then(function (response) {
                let data = response.data;
                user = data;
                let lang = user.user.language.toLowerCase();
                let country = user.user.country.toLowerCase();

                if (user.user.is_member === 0) {
                    window.location.replace("https://www.discover-shiseido.com/uk_en/membersonly/");
                }

                translationService.getLanguage(module, country, lang).then(function (res) {
                    let translation = JSON.stringify(res.data);
                    let translationToInterpolate = res.data;

                    let interpolation = {
                        '{red}': '<span class="font-color-red">',
                        '{/red}': '</span>',
                        '{quote}': '"',
                        '{br}': '<br>',
                        '{bold}': '<strong>',
                        '{/bold}': '</strong>',
                        '{italic}': '<em>',
                        '{/italic}': '</em>',
                        '{uppercase}': '<span class="uppercase">',
                        '{/uppercase}': '</span>',
                        '{small}': '<small>',
                        '{/small}': '</small>',
                        '{sup}': '<sup>',
                        '{/sup}': '</sup>',
                        '{nobreak}': '<span class="nobr">',
                        '{/nobreak}': '</span>',
                        '{span}': '<span>',
                        '{/span}': '</span>',
                    }

                    Object.keys(translationToInterpolate).forEach(key => {
                        let value = translationToInterpolate[key];

                        //Für jeden Sprachschlüssel alle interpolations druch gehen
                        Object.entries(interpolation).forEach(entry => {
                            let interpolationKey = entry[0];
                            let interpolationValue = entry[1];
                            // hat Sprachschlüssel einen interpolation Tags?
                            if(value.indexOf(interpolationKey) !== -1){
                                // Replace
                                value = value.replace(new RegExp(interpolationKey, 'g'), interpolationValue);
                                translationToInterpolate[key] = value;
                            }
                        });
                    });

                    translationToInterpolate = JSON.stringify(translationToInterpolate)
                    console.log(app);
                    i18n.setLocaleMessage("en", JSON.parse(translationToInterpolate))
                    console.log(i18n);

                    commit("init", {user, translationToInterpolate, lang, country, module});
                    localStorage.setItem("user", JSON.stringify(user));
                    localStorage.setItem("translation", translationToInterpolate);
                    localStorage.setItem("lang", lang);
                    localStorage.setItem("country", country);
                    localStorage.setItem("modulename", module);

                    document.querySelector('.preloader').classList.add("hide");

                    LRS.sendLRS("launched");
                })
            })

        },
        //#TODO: An User binden
        changeLanguage({commit}, language){
            commit("changeLanguage", language);
            localStorage.setItem("lang", language);

            //#TODO: Funktioniert akutell nur mit localen JSON Files => Da Anfrage nur über https://discover-shiseido.com/ gestattet ist
           /* translationService.getLanguage(module, user.user.country, user.user.language).then(function (res) {
                //commit("init", {state.user, t.translations, lang});

            })*/
        },
    },
    getters: {
        user(state){
            return state.user;
        },
        translation(state){
            return state.translation;
        },
        lang(state){
            return state.lang;
        },
        country(state) {
            return state.country;
        },        
        modulename(state){
            return state.modulename;
        }
    }
});